import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=42177980&"
import script from "./ShareLink.vue?vue&type=script&lang=js&"
export * from "./ShareLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42177980')) {
      api.createRecord('42177980', component.options)
    } else {
      api.reload('42177980', component.options)
    }
    module.hot.accept("./ShareLink.vue?vue&type=template&id=42177980&", function () {
      api.rerender('42177980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/stream/ShareLink.vue"
export default component.exports